import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import React, { Fragment } from 'react'

function ConfirmDialog({ open, title, onConfirm, onCancel }) {
    return (
        <Fragment>
            <Dialog
                maxWidth={'sm'}
                open={open}
            >
                <DialogContent>
                    <Typography variant="body1">{title}</Typography>
                </DialogContent>
                <DialogActions className='m-4 gap-1'>
                    <Button
                        onClick={onConfirm}
                        variant="contained"
                        size='small'
                        style={{
                            backgroundColor: "#cd6c4a",
                        }}
                    >
                        ตกลง
                    </Button>
                    <Button
                        onClick={onCancel}
                        variant="outlined"
                        size='small'
                        style={{
                            color: "#000",
                            borderColor: "#ccc",
                        }}
                    >
                        ยกเลิก
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    )
}

export default ConfirmDialog